import { render, staticRenderFns } from "./ResearchPigeanPheWAS.vue?vue&type=template&id=c24ff664&"
import script from "./ResearchPigeanPheWAS.vue?vue&type=script&lang=js&"
export * from "./ResearchPigeanPheWAS.vue?vue&type=script&lang=js&"
import style0 from "./ResearchPigeanPheWAS.vue?vue&type=style&index=0&id=c24ff664&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c24ff664')) {
      api.createRecord('c24ff664', component.options)
    } else {
      api.reload('c24ff664', component.options)
    }
    module.hot.accept("./ResearchPigeanPheWAS.vue?vue&type=template&id=c24ff664&", function () {
      api.rerender('c24ff664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/PIGEAN/ResearchPigeanPheWAS.vue"
export default component.exports